import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CLientReferralResponse, ChangeBulkClientRepresentativeRequest, ChangeSessionOwner, ClientById, ClientCouponResponse, ClientCreditBalanceListResponse, ClientCreditBalanceRequest, ClientCreditBalanceResponse, ClientMigration, ClientSalesReturnList, CreateProspectRequest, CreateProspectResponse, ListClientInteraction } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { ClientStatus } from '@fitness-force/enum';


@Injectable({
  providedIn: 'root'
})
export class ClientService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  httpPatchOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    })
  };

  constructor(private http: HttpClient) { }

  createProspect(client: CreateProspectRequest): Observable<CreateProspectResponse> {
    return this.http.post(environment.BASE_URL + '/tenants/' + client.prospect.createdin_tenant_id.toString() + CONST_URL_SEGEMENTS.CLIENT.POST_CLIENTS, client, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getProspects(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get( `${environment.BASE_URL}/tenants/${tenantId}/prospects`,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
   return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS,
    {
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getExClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });

    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/exclients`, {
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getIrregularClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {

      parsedParams = parsedParams.append(p.paramName, p.paramValue);
    });

    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + CONST_URL_SEGEMENTS.CLIENT.IRREGULAR_CLIENTS, {
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientById(clientId: any): Observable<any> {

    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + '/' + clientId, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientByIdNew(clientId: any): Observable<ClientById> {

    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + '/' + clientId, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  fetchClassApptTags(tenantId: any): Observable<any> {

    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.CLASS_APPT_TAGS, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  fetchServiceTypes(tenantId: any): Observable<any> {

    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.SERVICE_CAT, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  updateClientById(clientId: any, tenantId: any, clientData: any): Observable<any> {

    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + '/' + clientId, clientData, {
      headers: this.httpOptions.headers
    },

    ).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {

        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  clientAddToBlacklist(clientId: any, tenantId: any, clientData: any): Observable<any> {

    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + '/' + clientId + CONST_URL_SEGEMENTS.CLIENT.ADD_TO_BLACKLIST, clientData, {
      headers: this.httpOptions.headers
    },

    ).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {

        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  clientRemoveFromBlacklist(clientId: any, tenantId: any): Observable<any> {

    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + '/' + clientId + CONST_URL_SEGEMENTS.CLIENT.REMOVE_FROM_BLACKLIST, {
      headers: this.httpOptions.headers
    },
    ).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {

        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  changeClientRepresentative(clientId: any, tenantId: any, client_rep_data: any): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS + '/' + clientId + CONST_URL_SEGEMENTS.CLIENT.CHANGE_CLIENT_REP, client_rep_data, {
      headers: this.httpOptions.headers
    },
    ).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {

        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSubscriptions(clientId: any): Observable<any> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.SUBSCRIPTIONS}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSubscriptionSignup(clientId: any): Observable<any> {

    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.SUBSCRIPTION_SINGUPS}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );

  }

  getSingleSubscriptionById(clientId: any,subscriptionId:number): Observable<any> {

    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}/subscriptions/${subscriptionId}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );

  }

  getSubscriptionDetails(clientId: any, clietnSubscriptionId: any): Observable<any> {

    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.SUBSCRIPTIONS}/${clietnSubscriptionId}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );

  }

  getSubscriptionInvoices(clientId: any, clietnSubscriptionId: any,allparams: any = null): Observable<any> {
    let parsedParams = new HttpParams()
    if(allparams != null)
    {
      allparams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.SUBSCRIPTIONS}/${clietnSubscriptionId}${CONST_URL_SEGEMENTS.CLIENT.INVOICES}`, {
      headers: this.httpOptions.headers,params: parsedParams
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );

  }

  getPaymentTimeline(clientId: any, clietnSubscriptionId: any): Observable<any> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.SUBSCRIPTIONS}/${clietnSubscriptionId}${CONST_URL_SEGEMENTS.CLIENT.PAYMENT_TIMELINE}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {

        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {

          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientInvoices(clientId: any,allparams: any = null): Observable<any> {
    let parsedParams = new HttpParams()
    if(allparams != null)
    {
      allparams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.INVOICES}`, {
      headers: this.httpOptions.headers,params: parsedParams
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientPayments(clientId: any,allparams: any = null): Observable<any> {
    let parsedParams = new HttpParams()
    if(allparams != null)
    {
      allparams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.PAYMENTS}`, {
      headers: this.httpOptions.headers,params: parsedParams
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientSalesReturns(clientId: any): Observable<ClientSalesReturnList> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.SALES_RETURNS}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientPaymentMethods(clientId: any): Observable<any> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.PAYMENT_METHODS}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }


  getClientInteractions(clientId: any, allParams: Array<any>): Observable<ListClientInteraction> {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {
       parsedParams = parsedParams.append(p.paramName, p.paramValue);
     });
    }
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.INTERACTIONS}`,
     {headers: this.httpOptions.headers , params: parsedParams}).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientStatusHtml(status: string): string {
    switch (status) {
      case ClientStatus.Prospect.toString():
      case ClientStatus[ClientStatus.Prospect]:
        return '<span class="bg-pink-50 text-green-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">PROSPECT</span>';
      case ClientStatus.Trial.toString():
      case ClientStatus[ClientStatus.Trial]:
        return '<span class="bg-cyan-50 text-cyan-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">TRIAL</span>';
      case ClientStatus.Client.toString():
      case ClientStatus[ClientStatus.Client]:
        return '<span class="bg-green-50 text-green-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">MEMBER</span>';
      case ClientStatus.ClientNonMember.toString():
      case ClientStatus[ClientStatus.ClientNonMember]:
        return '<span class="bg-yellow-50 text-yellow-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">NON-MEMBER</span>';
      case ClientStatus.ExClient.toString():
      case ClientStatus[ClientStatus.ExClient]:
        return '<span class="surface-50 text-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">EX-MEMBER</span>';
      case ClientStatus.BlockedClient.toString():
      case ClientStatus[ClientStatus.BlockedClient]:
        return '<span class="bg-bluegray-50 text-bluegray-500 px-2 py-1 font-bold border-round text-xxs">TERMINATED</span>';
       case ClientStatus.ExClientNonMember.toString():
       case ClientStatus[ClientStatus.ExClientNonMember]:
        return '<span class="surface-100 text-800 px-2 py-1 font-bold border-round text-xxs">EX-CLIENT NON-MEMBER</span>';
      default:
        return '';
    }
  }

  ChangeSessionOwner(tenantId: number, clientId: number, subscriptionId:number,membershipId:number, sessionOwnerData: ChangeSessionOwner): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.SUBSCRIPTION.POST_CHANGE_SESSION_OWNER.replace('{tenant_id}', tenantId.toString())
    .replace('{client_id}', clientId.toString())
    .replace('{client_subs_id}', subscriptionId.toString())
    .replace('{clt_membership_id}', membershipId.toString());
    return this.http.post<ChangeSessionOwner>(url,sessionOwnerData,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  getMigrationData(clientId: any): Observable<ClientMigration> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.MIGRATION}`,
     {headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  ChangePassword(tenantId:number,clientId: number,NEW_PASSWORD: string): Observable<any> {
    const params = {'new_password': NEW_PASSWORD};
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.RESET_PASSWORD.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.post(url,
    params, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) return throwError(() => new NotFoundError(error));
        return throwError(() => new AppErrors(error));
      })
    );
  }


  getClientSessionInventory(tenantId: number, clientId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.SESSION_INVENTORY.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }


  patchClient(clientId:number,tenantId:number, request:any)
  {
    const url = environment.BASE_URL+"/tenants/"+tenantId+"/clients/"+ clientId;
    return this.http.patch(url, request, this.httpPatchOptions).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  AddClientCreditBalance(tenantId:number, clientId:number,clientCreditBalanceRequest: ClientCreditBalanceRequest): Observable<ClientCreditBalanceResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.ADD_CREDIT_BALANCE.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.post<ClientCreditBalanceRequest>(url,clientCreditBalanceRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  getClientCreditBalance(clientId:number): Observable<number>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CREDIT_BALANCE.replace('{client_id}', clientId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  getClientCreditBalanceByTenantId(clientId:number, tenantId:number): Observable<number>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CREDIT_BALANCE_BY_TENANT.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  changeClientRepresentativeBulk(tenantId: any, client_rep_data: ChangeBulkClientRepresentativeRequest): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TENANT.GET_TENANTBYID + '/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.CHANGE_CLIENT_REP, client_rep_data, {
      headers: this.httpOptions.headers
    },
    ).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientCreditBalanceList(clientId:number): Observable<ClientCreditBalanceListResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CREDIT_BALANCE_LIST.replace('{client_id}', clientId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  getClientReferrals(tenantId:number,clientId:number): Observable<CLientReferralResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENT_REFERRALS.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  getClientEligibleCoupons(tenantId:number,clientId:number): Observable<ClientCouponResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENT_COUPONS.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  getClientFitnessData(tenantId: number, payload: any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.GET_CLIENT_FITNESS_DATA.replace('{tenant_id}', tenantId.toString());
    return this.http.post(url, payload, {headers: this.httpOptions.headers}).pipe(map((res: any) => {
        return res;

    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  transferProspect(tenantId: number, transferProspectData: any): Observable<any> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/clients/prospect_transfer`, transferProspectData, {
      headers: this.httpOptions.headers
    },
    ).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getClientHistory(clientId: number): Observable<any> {
    return this.http.get(`${environment.BASE_URL}/clients/${clientId}/prospect_efffective_history`, {
      headers: this.httpOptions.headers
    }).pipe(map((res: any) => {
      return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  createProspectFromContact(tenantId: number,contactId: number, client: CreateProspectRequest): Observable<CreateProspectResponse> {
    return this.http.post(environment.BASE_URL + '/tenants/' + tenantId + CONST_URL_SEGEMENTS.CLIENT.POST_CLIENTS_FROM_CONTACT.replace('{contact_id}', contactId.toString()), client, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  validateKeyfob(tenantId: number, keyfobNumber: string): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.VALIDATE_KEYFOB.replace('{tenant_id}', tenantId.toString());
    const body = { keyFob: keyfobNumber };
    return this.http.post(url, body, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  deleteDigitalKeyFob(tenantId: number, clientId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.DELETE_DIGITAL_KEYFOB.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString());
    return this.http.delete(url, this.httpOptions).pipe(map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}
